import { observable } from 'mobx';
import store from 'client/store';

export default class AllSitesStore {
	@observable records = store.ui.allSites;
	type = store.ui.siteTypes[0];
	search = '';

	onSiteTypeChange = (type) => {
		this.type = type;
		this.fetchRecords();
	};

	fetchRecords = async () => {
		const trimmedSearch = this.search.trim();
		// отдает только доступные типы. Желательно как то вынести в access Site
		const types = await store.model.SiteType.find({ where: { or: [ { isHide: false }, { isHide: null } ] } });
		const typeIds = types.map(type => type.id);
		this.records = await store.model.Site.find({
			where: {
				typeId: this.type?.id ? this.type?.id : { inq: typeIds },
				publish: true,
				domain: { neq: store.ui.site.domain },
			},
			limit: 18,
			search: trimmedSearch || undefined,
			order: 'priority DESC NULLS LAST, name ASC'
		});
	};

	onSearchSubmit = async (value) => {
		this.search = value;
		this.fetchRecords();
	};
}
